import reportError from 'ha/helpers/bugsnag/reportError';
import {
  getUserId,
  getIsAliased,
  getUserIdAlias,
  getUserTraits,
} from 'ha/modules/AuthLogic/selectors';

const identify = (aliasId, data) => ({
  type: 'Analytics.identify',
  meta: {
    analytics: {
      type: 'identify',
      payload: {
        aliasId,
        data,
      },
    },
  },
});

const alias = aliasId => ({
  type: 'Analytics.alias',
  meta: {
    analytics: {
      type: 'alias',
      payload: aliasId,
    },
  },
});

/**
 * @returns {import('ha/myredux/types').Thunk}
 */
const identifyUser = () => (dispatch, getState, { apiV2, segment, tiktok }) => {
  const state = getState();

  const userId = getUserId(state);

  if (!userId) {
    segment.identifyUser();

    return;
  }

  const aliasId = getUserIdAlias(state);
  const data = getUserTraits(state);

  tiktok.identify({
    external_id: aliasId,
    email: data.email,
  });

  if (getIsAliased(state)) {
    dispatch(identify(aliasId, data));
    segment.identifyUser();
  } else {
    dispatch(alias(aliasId));

    apiV2.updateUser(userId, { isAliased: true }).catch(reportError);

    setTimeout(() => {
      dispatch(identify(aliasId, data));
      segment.identifyUser();
    }, 2000);
  }
};

export default identifyUser;
